import { lazy } from 'react';
/** Открывает карточку клиента */
export const ClientDetailsPageAsync = lazy(() => import('./ClientDetails/ClientDetailsPage'));